import React, { useState, useEffect } from 'react';
import './HomeScreen.css';
import Logo from '../../assets/images/tektap.svg';
import TTHRMSLogo from '../../assets/images/tthrms.svg';

// Icons
const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 12h18M3 6h18M3 18h18" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
  </svg>
);

const MailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const LocationIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const LoginIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
    <polyline points="10 17 15 12 10 7" />
    <line x1="15" y1="12" x2="3" y2="12" />
  </svg>
);

const ArrowRightIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

const CheckIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const BankIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M3 21h18M3 10h18M5 6l7-3 7 3M4 10v11M20 10v11M8 14v3M12 14v3M16 14v3" />
  </svg>
);

const HealthIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
  </svg>
);

const TTHRMSIcon = () => (
  <img src={TTHRMSLogo} alt="TTHRMS" style={{ width: 48, height: 48, objectFit: 'contain' }} />
);


const navLinks = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About Us' },
  { id: 'services', label: 'Services' },
  { id: 'products', label: 'Products' },
  { id: 'contact', label: 'Contact Us' },
];

const services = [
  { 
    name: 'Technical Services', 
    isGroup: true,
    subItems: ['Embedded Services', 'Cloud Services', 'Mobility Services']
  },
  { name: 'Training Services' },
  { name: 'RPO' },
  { 
    name: 'Staff Augmentation',
    hasDetails: true,
    details: [
      {
        title: 'Flexible Engagement',
        description: 'Short-term, long-term, or project-based models',
        icon: 'calendar'
      },
      {
        title: 'Seamless Integration',
        description: 'Accelerate project delivery with our team',
        icon: 'team'
      },
      {
        title: 'Expert Resources',
        description: 'Engineers / SMEs / Architects / Tech. Consultation',
        icon: 'expert'
      }
    ]
  },
  { name: 'Talent Search' },
];

// Hero Carousel Services
const heroServices = [
  {
    id: 'technical-services',
    title: 'Technical Services',
    description: 'Comprehensive technical solutions including embedded systems, cloud infrastructure, and mobile application development.',
    cards: [
      { title: 'Embedded Services', description: 'Hardware-software integration, IoT solutions, and firmware development', icon: 'chip' },
      { title: 'Cloud Services', description: 'Cloud migration, infrastructure setup, and DevOps solutions', icon: 'cloud' },
      { title: 'Mobility Services', description: 'Native and cross-platform mobile app development', icon: 'mobile' }
    ]
  },
  {
    id: 'staff-augmentation',
    title: 'Staff Augmentation',
    description: 'Scale your team with our expert resources. We provide flexible engagement models to help you achieve your business goals efficiently.',
    cards: [
      { title: 'Flexible Engagement', description: 'Short-term, long-term, or project-based models tailored to your needs', icon: 'calendar' },
      { title: 'Seamless Integration', description: 'Our experts integrate with your team to accelerate project delivery', icon: 'team' },
      { title: 'Expert Resources', description: 'Engineers / SMEs / Architects / Tech. Consultation', icon: 'expert' }
    ]
  },
  {
    id: 'training-services',
    title: 'Training Services',
    description: 'Empower your workforce with cutting-edge skills through our comprehensive training programs.',
    cards: [
      { title: 'Corporate Training', description: 'Customized training programs for your organization', icon: 'corporate' },
      { title: 'Technical Workshops', description: 'Hands-on workshops on latest technologies', icon: 'workshop' },
      { title: 'Certification Programs', description: 'Industry-recognized certification courses', icon: 'certificate' }
    ]
  },
  {
    id: 'rpo',
    title: 'RPO Services',
    description: 'Recruitment Process Outsourcing to streamline your hiring and build exceptional teams.',
    cards: [
      { title: 'End-to-End Recruitment', description: 'Complete hiring process management', icon: 'recruitment' },
      { title: 'Talent Pipeline', description: 'Build a robust pipeline of qualified candidates', icon: 'pipeline' },
      { title: 'Employer Branding', description: 'Enhance your brand to attract top talent', icon: 'brand' }
    ]
  },
  {
    id: 'talent-search',
    title: 'Talent Search',
    description: 'Find the perfect candidates with our specialized talent acquisition services.',
    cards: [
      { title: 'Executive Search', description: 'C-level and senior management recruitment', icon: 'executive' },
      { title: 'Technical Hiring', description: 'Specialized IT and engineering talent acquisition', icon: 'technical' },
      { title: 'Bulk Hiring', description: 'Large-scale recruitment for rapid scaling', icon: 'bulk' }
    ]
  }
];

const technologies = [
  { name: 'Microsoft', color: '#00A4EF' },
  { name: 'Oracle', color: '#F80000' },
  { name: 'SAP', color: '#0FAAFF' },
  { name: 'Java', color: '#ED8B00' },
  { name: 'Python', color: '#3776AB' },
  { name: 'React', color: '#61DAFB' },
  { name: 'AWS', color: '#FF9900' },
  { name: 'Azure', color: '#0089D6' },
  { name: 'AI/ML', color: '#9B59B6' },
  { name: 'IoT', color: '#27AE60' },
];

const industries = [
  {
    id: 'banking',
    title: 'Spoar',
    description: 'With the regulations changing rapidly across the globe, the Financial sector has undergone massive changes.',
    icon: BankIcon,
    color: '#3B82F6',
  },
  {
    id: 'healthcare',
    title: 'Salt POS',
    description: 'The days of rooms filled with medical information in paper files are dwindling away.',
    icon: HealthIcon,
    color: '#10B981',
  },
  {
    id: 'manufacturing',
    title: 'TTHRMS',
    description: 'TTHRMS industries most often have high capital expenditures in installation of equipments.',
    icon: TTHRMSIcon,
    color: '#F59E0B',
  },
];

const features = [
  { title: 'Pay As You Go', description: 'Flexible payment options' },
  { title: 'No Upfront Fee', description: 'Start without investment' },
  { title: 'No Long-Term Contracts', description: 'Freedom to choose' },
  { title: 'Competitive Pricing', description: 'Best value for money' },
  { title: 'Pay For Performance', description: 'Results-driven approach' },
];

const HomeScreen = ({ onGetStarted }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showServiceModal, setShowServiceModal] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const nextSlide = () => {
    setActiveSlide((prev) => (prev + 1) % heroServices.length);
  };

  const prevSlide = () => {
    setActiveSlide((prev) => (prev - 1 + heroServices.length) % heroServices.length);
  };

  // Auto-scroll carousel every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % heroServices.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const getIconSvg = (iconName) => {
    const icons = {
      calendar: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      ),
      team: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      expert: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      ),
      chip: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="4" y="4" width="16" height="16" rx="2" />
          <rect x="9" y="9" width="6" height="6" />
          <line x1="9" y1="1" x2="9" y2="4" />
          <line x1="15" y1="1" x2="15" y2="4" />
          <line x1="9" y1="20" x2="9" y2="23" />
          <line x1="15" y1="20" x2="15" y2="23" />
          <line x1="20" y1="9" x2="23" y2="9" />
          <line x1="20" y1="14" x2="23" y2="14" />
          <line x1="1" y1="9" x2="4" y2="9" />
          <line x1="1" y1="14" x2="4" y2="14" />
        </svg>
      ),
      cloud: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z" />
        </svg>
      ),
      mobile: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
          <line x1="12" y1="18" x2="12.01" y2="18" />
        </svg>
      ),
      corporate: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 21h18M9 8h1M9 12h1M9 16h1M14 8h1M14 12h1M14 16h1M5 21V5a2 2 0 012-2h10a2 2 0 012 2v16" />
        </svg>
      ),
      workshop: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" />
        </svg>
      ),
      certificate: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="8" r="6" />
          <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
        </svg>
      ),
      recruitment: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
          <circle cx="8.5" cy="7" r="4" />
          <line x1="20" y1="8" x2="20" y2="14" />
          <line x1="23" y1="11" x2="17" y2="11" />
        </svg>
      ),
      pipeline: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
        </svg>
      ),
      brand: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
          <line x1="4" y1="22" x2="4" y2="15" />
        </svg>
      ),
      executive: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      ),
      technical: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="16 18 22 12 16 6" />
          <polyline points="8 6 2 12 8 18" />
        </svg>
      ),
      bulk: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 00-3-3.87" />
          <path d="M16 3.13a4 4 0 010 7.75" />
        </svg>
      )
    };
    return icons[iconName] || icons.expert;
  };

  return (
    <div className="landing-page">
      {/* Navigation */}
      <nav className="main-nav">
        <div className="nav-content">
          <div className="logo">
            <img src={Logo} alt="TekTap HRMS" className="logo-image" />
          </div>

          <div className={`nav-links ${mobileMenuOpen ? 'open' : ''}`}>
            {navLinks.map((link) => (
              link.id === 'services' ? (
                <div key={link.id} className="nav-dropdown">
                  <a href={`#${link.id}`} className="nav-link">
                    {link.label}
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </a>
                  <div className="dropdown-menu">
                    {services.map((service, index) => (
                      service.isGroup ? (
                        <div key={index} className="dropdown-group">
                          <span className="dropdown-group-title">{service.name}</span>
                          {service.subItems.map((subItem, subIndex) => (
                            <span key={subIndex} className="dropdown-item sub">{subItem}</span>
                          ))}
                        </div>
                      ) : service.hasDetails ? (
                        <span 
                          key={index} 
                          className="dropdown-item with-arrow"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowServiceModal(service);
                          }}
                        >
                          {service.name}
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M9 18l6-6-6-6" />
                          </svg>
                        </span>
                      ) : (
                        <span key={index} className="dropdown-item">{service.name}</span>
                      )
                    ))}
                  </div>
                </div>
              ) : (
                <a key={link.id} href={`#${link.id}`} className="nav-link">
                  {link.label}
                </a>
              )
            ))}
          </div>

          <button 
            className="login-btn"
            onClick={onGetStarted}
            title="Login to HRMS Portal"
          >
            <LoginIcon />
            <span>Login</span>
          </button>

          <button 
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <MenuIcon />
          </button>
        </div>
      </nav>

      {/* Hero Section - Services Carousel */}
      <section className="hero-section">
        <div className="hero-carousel">
          {/* Carousel Navigation Arrows */}
          <button className="carousel-arrow prev" onClick={prevSlide}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
          <button className="carousel-arrow next" onClick={nextSlide}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>

          {/* Carousel Slides */}
          <div className="carousel-track">
            {heroServices.map((service, index) => (
              <div 
                key={service.id} 
                className={`carousel-slide ${index === activeSlide ? 'active' : ''}`}
              >
                <div className="hero-content staff-aug">
                  <div className="hero-text-center">
                    <h1 className="hero-title">
                      <span className="highlight">{service.title.split(' ')[0]}</span> {service.title.split(' ').slice(1).join(' ')}
                    </h1>
                    <p className="hero-description">{service.description}</p>
                  </div>
                  <div className="hero-cards-grid">
                    {service.cards.map((card, cardIndex) => (
                      <div key={cardIndex} className="hero-service-card">
                        <div className="hero-service-icon">
                          {getIconSvg(card.icon)}
                        </div>
                        <h3>{card.title}</h3>
                        <p>{card.description}</p>
                      </div>
                    ))}
                  </div>
                  <div className="hero-buttons center">
                    <button className="btn-secondary">
                      Learn More
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Carousel Dots */}
          <div className="carousel-dots">
            {heroServices.map((service, index) => (
              <button
                key={service.id}
                className={`carousel-dot ${index === activeSlide ? 'active' : ''}`}
                onClick={() => setActiveSlide(index)}
                title={service.title}
              />
            ))}
          </div>

          {/* Carousel Labels */}
          <div className="carousel-labels">
            {heroServices.map((service, index) => (
              <button
                key={service.id}
                className={`carousel-label ${index === activeSlide ? 'active' : ''}`}
                onClick={() => setActiveSlide(index)}
              >
                {service.title}
              </button>
            ))}
          </div>
        </div>
        <div className="hero-wave">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white"/>
          </svg>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section" id="about">
        <div className="about-container">
          {/* Left Side - Images */}
          <div className="about-images">
            <div className="about-img-main">
              <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=500&fit=crop" alt="Professional working" />
            </div>
            <div className="about-img-secondary">
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=350&h=250&fit=crop" alt="Team collaboration" />
            </div>
            <div className="experience-badge">
              <span className="exp-number">7</span>
              <span className="exp-text">Years of<br/>Experience</span>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="about-content">
            <div className="about-label">— About Us —</div>
            <h2 className="about-title">
              Supercharge <span className="highlight">Your Business Growth</span> with Our Cutting-Edge IT Solutions
            </h2>
            <p className="about-desc">
              At TEKTAP, we're more than just a software company—we're your strategic technology partner. 
              With a passion for innovation and a commitment to excellence, we specialize in delivering 
              tailor-made software solutions that transform businesses, streamline operations, and 
              accelerate digital growth.
            </p>
            
            <div className="about-features">
              <div className="feature-item">
                <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Innovative IT Solutions Expert Support & Consulting</span>
              </div>
              <div className="feature-item">
                <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Seamless Digital Transformation Business Automation</span>
              </div>
              <div className="feature-item">
                <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Cloud Solutions for Modern Enterprises</span>
              </div>
            </div>

            <div className="about-highlight-box">
              <div className="highlight-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <div className="highlight-text">
                <h4>Innovative IT Solutions</h4>
                <p>Stay ahead with technology tailored to your business needs.</p>
              </div>
            </div>

            <div className="about-highlight-box">
              <div className="highlight-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  <circle cx="19" cy="5" r="2" />
                  <path d="M19 7v2" />
                </svg>
              </div>
              <div className="highlight-text">
                <h4>Cloud Solutions</h4>
                <p>Secure, scalable, and efficient cloud services to power your growth. Cloud Solutions for Modern Enterprises</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="industries-section" id="products">
        <div className="section-content">
          <div className="about-badge">Products</div>
          <h2 className="section-title">
            Products <span className="highlight">We Offer</span>
          </h2>
          <p className="section-description center">
            Our goal is to help companies maintain or achieve best-in-class positions 
            in their respective industries.
          </p>
          <div className="industries-grid">
            {industries.map((industry) => {
              const IconComponent = industry.icon;
              return (
                <div key={industry.id} className="industry-card">
                  <div 
                    className="industry-icon"
                    style={{ backgroundColor: `${industry.color}15`, color: industry.color }}
                  >
                    <IconComponent />
                  </div>
                  <h3>{industry.title}</h3>
                  <p>{industry.description}</p>
                  <button type="button" className="read-more">
                    Read More <ArrowRightIcon />
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="main-footer">
        <div className="footer-content">
          <div className="footer-col">
            <div className="footer-logo">
              <img src={Logo} alt="TekTap HRMS" className="footer-logo-image" />
            </div>
            <p className="footer-desc">
              Providing innovative software solutions to businesses globally since years.
            </p>
          </div>

          <div className="footer-col" id="contact">
            <h4>Contact Us</h4>
            <ul>
              <li>
                <span className="footer-link">
                  <PhoneIcon /> +91 40 40272495
                </span>
              </li>
              <li>
                <a href="mailto:hr@tektap.in" className="footer-link">
                  <MailIcon /> hr@tektap.in
                </a>
              </li>
              <li>
                <span className="footer-link">
                  <LocationIcon /> Unit 1004, 10th Floor, Jain Sadguru Capital Park, Madhapur, Hyderabad, Telangana 500081, India
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>All Rights Reserved © 2025 | TEKTAP CONSULTING PRIVATE LIMITED</p>
        </div>
      </footer>

      {/* Service Detail Modal */}
      {showServiceModal && (
        <div className="service-modal-overlay" onClick={() => setShowServiceModal(null)}>
          <div className="service-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowServiceModal(null)}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
            <h2 className="modal-title">{showServiceModal.name}</h2>
            <div className="modal-cards">
              {showServiceModal.details.map((detail, detailIndex) => (
                <div key={detailIndex} className="modal-card">
                  <div className="modal-card-icon">
                    {detail.icon === 'calendar' && (
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                        <line x1="16" y1="2" x2="16" y2="6" />
                        <line x1="8" y1="2" x2="8" y2="6" />
                        <line x1="3" y1="10" x2="21" y2="10" />
                      </svg>
                    )}
                    {detail.icon === 'team' && (
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                    )}
                    {detail.icon === 'expert' && (
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                      </svg>
                    )}
                  </div>
                  <h3 className="modal-card-title">{detail.title}</h3>
                  <p className="modal-card-desc">{detail.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeScreen;

